import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles'
import {
  white,
  MQ,
  tableGray,
  black, tabletMin, headerMaxWidth,
} from '@css/constants'

export const PublicHeaderWrapper = styled('header')(css`
  background: ${white};
  position: sticky;
  top: 0;
  z-index: 99;

  ${MQ.SMALL_SCREENS} {
    box-shadow: 0px 4px 12px rgba(26, 28, 31, 0.15);
  }
`)

export const TopHeader = styled('div')(css`
  padding: 4px 15px;
  border-bottom: 1px solid ${tableGray};
  background: ${white};
`)

export const TopHeaderContent = styled('div')(css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`);

export const HIQLogoWrapper = styled('a')(css`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  text-decoration: none;

  & > svg {
    position: relative;
    top: -2px;
  }
`)

export const LogoText = styled('div')(css`
  ${FontNormal(400)};
  ${fontSize(12)};
  position: relative;
  left: 12px;
  top: 2px;
  letter-spacing: 0.5px;
  color: ${black};

  ${MQ.SMALL_SCREENS} {
    ${fontSize(8)};
  }
`)

export const ActionsWrapper = styled('div')(css`
  display: flex;
  align-items: center;
`)

export const HeaderText = styled.div`
  margin-right: auto;
  align-self: center;
  ${fontSize(20)};
  ${FontNormal(400)};
  margin-left: 20px;
  border-left: 1px solid;
  padding-left: 20px;
  
  @media(max-width: ${tabletMin}) {
    display: none;
  }
`;